import React from 'react';
import './Benefits.css';

const Benefits = () => {
  const benefits = [
    {
      title: 'Reduce AWS Costs by 30%',
      description: 'Our customers typically see 20-40% reduction in their AWS bills within the first month of implementation.',
      metric: '30%',
      label: 'Average Savings'
    },
    {
      title: 'Automated Cost Management',
      description: 'Set it and forget it. Our plugins work 24/7 to optimize your resources without manual intervention.',
      metric: '24/7',
      label: 'Automation'
    },
    {
      title: 'Enterprise-Grade Security',
      description: 'Bank-level security with minimal AWS permissions. Your data stays in your AWS account.',
      metric: '100%',
      label: 'Secure'
    },
    {
      title: 'Rapid Implementation',
      description: 'Get up and running in minutes, not weeks. No complex setup or lengthy onboarding process.',
      metric: '5min',
      label: 'Setup Time'
    }
  ];

  return (
    <section id="benefits" className="benefits">
      <div className="container">
        <div className="section-header text-center">
          <h2>Why Choose Finoptic?</h2>
          <p>Join hundreds of companies already optimizing their AWS costs with Finoptic</p>
        </div>
        
        <div className="benefits-grid grid grid-2">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card card">
              <div className="benefit-metric">
                <span className="metric-number">{benefit.metric}</span>
                <span className="metric-label">{benefit.label}</span>
              </div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
        
        <div className="testimonial">
          <div className="testimonial-content">
            <blockquote>
              "Finoptic helped us reduce our AWS costs by 35% in just two months. The automated plugins are incredibly powerful and the dashboard gives us the visibility we never had before."
            </blockquote>
            <div className="testimonial-author">
              <div className="author-info">
                <strong>Sarah Johnson</strong>
                <span>CTO, TechCorp Inc.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;